import React from 'react';
import { merchantProfile, sampleTransaction } from '../../data/gtbankUatData';
import { UatInfoRow, UatNote, UatPageShell } from './UatDocumentationPage';

export default function MpgsPendingPage() {
  return (
    <UatPageShell
      title="MPGS Hosted Checkout Screen"
      breadcrumb="MPGS Pending"
      heading="MPGS Hosted Checkout Screen"
      subtitle="Pending GTBank MPGS sandbox credentials"
    >
      <UatInfoRow label="Status" value="Pending GTBank MPGS sandbox credentials" accent />
      <UatInfoRow label="Reference Number" value={sampleTransaction.referenceNumber} />
      <UatInfoRow label="Amount" value={sampleTransaction.amount} />
      <UatInfoRow label="Currency" value={sampleTransaction.currency} />
      <UatInfoRow label="Merchant" value={merchantProfile.name} />
      <UatNote>
        This screen will be replaced with the actual MPGS Hosted Checkout page after GTBank provides
        sandbox credentials.
      </UatNote>
    </UatPageShell>
  );
}
